export default __webpack_public_path__ + "static/media/screen-3.e7b2ee36.jpg";